<!-- Empty component template because this component inserts its viewable contents via dialog modals -->
<div *ngIf="!(showLoadingIcon$ | async); else loadingIcon"></div>

<ng-template #loadingIcon>
	<div class="w-full h-full inline">
		<atomic-loading-icon></atomic-loading-icon>
	</div>
	<div class="loading w-full top-[7.5rem]">
		{{ showLoadingMessage$ | async }}
	</div>
</ng-template>
